export default "__VITE_ASSET__D59cPy68__"